import { Button, IconButton } from 'src/components/atoms';
import { calcSpacing } from 'src/components/foundations';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const PageHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  padding: ${calcSpacing(2.5)}px;
  flex-shrink: 0;
  overflow: visible;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    align-items: flex-start;
  }
`;

export const HeaderLeftSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: auto;
  min-height: 40px;

  @media (max-width: 1024px) {
    align-items: flex-start;
  }
`;

export const HeaderLeading = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 40px;
  padding-right: 12px;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  position: relative;
`;

export const HeaderTitle = styled.h1`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH1)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  height: auto;
  line-height: 38px;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1024px) {
    white-space: normal;
    line-height: 1.2;
    word-break: break-word;
  }
`;

export const InfoIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  &:focus-visible {
    outline: 2px solid
      ${(props) => props.theme.atlas.semantic.color.ui.focusRing};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const InfoContentContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 9999;
`;

export const HeaderActionsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-shrink: 0;
  height: 40px;
  padding-left: 16px;
`;

const headerIconButtonStyles = `
  && {
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 12px;
    padding: 8px;
    flex-shrink: 0;
    cursor: pointer;
  }

  & * {
    cursor: pointer;
  }
`;

export const BackButton = styled(IconButton)`
  ${headerIconButtonStyles}

  && {
    background-color: transparent;
    border: none;
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: ${(props) =>
        props.theme.atlas.semantic.color.action.secondary.hoverFill};
    }
  }
`;

export const HeaderSecondaryButton = styled(Button)<{ $compact?: boolean }>`
  && {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    min-width: 114px;
    width: ${({ $compact }) => ($compact ? '114px' : 'auto')};
    max-width: ${({ $compact }) => ($compact ? '114px' : 'none')};
    padding: 8px 12px;
    height: 40px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.emphasis)};
    font-weight: 600;
    letter-spacing: 0.2px;
  }
`;

export const HeaderPrimaryButton = styled(Button)<{ $compact?: boolean }>`
  && {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 12px;
    min-width: 162px;
    width: ${({ $compact }) => ($compact ? '162px' : 'auto')};
    max-width: ${({ $compact }) => ($compact ? '162px' : 'none')};
    padding: 8px 12px;
    height: 40px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.emphasis)};
    font-weight: 600;
    letter-spacing: 0.2px;
  }
`;

export const HeaderPublishIcon = styled(StyledIconInButton)`
  && {
    font-size: 24px;
    width: 24px;
    height: 24px;
    padding: 0;
  }
`;
